import { Field, Label, Radio } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/16/solid";
import { SparklesIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import { Fragment } from "react";

interface PurchaseTypeOptionsProps {
  compareAtPrice?: number;
  highlight?: boolean;
  label: string;
  price: number;
  value: boolean;
}

export default function PurchaseTypeOptions({
  label,
  value,
  price,
  compareAtPrice,
  highlight = false,
}: PurchaseTypeOptionsProps) {
  return (
    <Field
      className="
      xw-full xh-full
      xflex xgap-6 xitems-center
      xborder-4 xborder-dark-green xrounded-3xl

      xpx-4 xpy-4
      md:xpx-8 md:xpy-6
    "
    >
      <Radio value={value} as={Fragment}>
        {({ checked }) => (
          <span
            className={clsx(
              "xgroup xflex xitems-center xjustify-center",
              "xsize-10 xrounded-full",
              "xborder-[3px] xborder-dark-green",
              "xcursor-pointer",
              checked ? "xbg-light-green/40" : "xbg-transparent"
            )}
          >
            {checked && <CheckIcon className="xsize-10 xtext-dark-green" />}
          </span>
        )}
      </Radio>
      <div className="xflex xgrow xh-full xitems-center xjustify-between xgap-4">
        <Label
          className="
            xfont-grotesque xfont-semibold
            xtext-extra-dark-green

            xtext-3xl xl:xtext-4xl

            xflex xitems-center
            xh-full
            xpb-2
            xgrow xshrink-0
            xcursor-pointer

          "
        >
          <span className="xrelative xinline-block xgrow">
            <span>{label}</span>
            {highlight && (
              <span
                className="
                  xabsolute
                  x-translate-y-1/3
                  xpointer-events-none
                "
              >
                <SparklesIcon className="xsize-10 xtext-orange" />
              </span>
            )}
          </span>
        </Label>
        <div className="xflex xitems-center xgap-4 xgrow-0 xshrink">
          <Label
            className="
                xfont-grotesque xfont-semibold
              xtext-extra-dark-green
                xtext-3xl xl:xtext-4xl
                xcursor-pointer
                xpb-2
                xflex xflex-wrap xjustify-end md:xgap-2
              "
          >
            {compareAtPrice && (
              <span className="xline-through xtext-nowrap">
                <Price price={compareAtPrice} currency={"USD"} />
              </span>
            )}
            <span
              className={clsx(
                "xtext-nowrap",
                compareAtPrice ? "xfont-black" : "xfont-semibold"
              )}
            >
              {" "}
              <Price price={price} currency={"USD"} />
            </span>
          </Label>
        </div>
      </div>
    </Field>
  );
}

function Price({ price, currency }: { price: number; currency: string }) {
  const priceInDollars = price / 100;
  return (
    <>
      {currency} ${priceInDollars.toFixed(2)}
    </>
  );
}
